// extracted by mini-css-extract-plugin
export default {"storyDetailListWrapper":"c-r_fR","storyDetailListWrapper__title":"c-r_fS","storyDetailListWrapper__timeline":"c-r_fT","storyDetailListWrapper__list":"c-r_fU"};